import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus_icon_jax_3d9b6859b044cd347cf887ed6896519c",
  "use": "plus_icon_jax_3d9b6859b044cd347cf887ed6896519c-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol viewBox=\"0 0 20 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus_icon_jax_3d9b6859b044cd347cf887ed6896519c\"><path d=\"M1.5 9h17M10 1v17\" stroke=\"#FFF\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol